import { Injectable } from '@angular/core';
import { ApiService } from '../../api/api.service';
import {
  ICreateParentGroup,
  IGetParentGroupFilters,
  IParentGroup,
  IUpdateParentGroup,
} from '../../../../pages/management/services/service-parent-groups/interface/parent-groups.interface';

@Injectable({
  providedIn: 'root',
})
export class ServiceParentGroupsService {
  constructor(private readonly apiService: ApiService) {}

  create(data: ICreateParentGroup) {
    return this.apiService.post<IParentGroup>('service-parent-groups/create', data);
  }
  update(data: IUpdateParentGroup) {
    return this.apiService.patch<IParentGroup>(
      'service-parent-groups/update',
      data
    );
  }
  delete(id: number) {
    return this.apiService.delete<{success:boolean}>(
      `service-parent-groups/delete/${id}`,
    );
  }
  getAll(data: IGetParentGroupFilters) {
    return this.apiService.post<IParentGroup[]>(
      'service-parent-groups/getAll',
      data
    );
  }
}
